var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-header" },
        [
          _c(
            "b-row",
            [
              _c("b-col", [_c("h4", [_vm._v(" Devoluções Solicitadas ")])]),
              _vm._v(" "),
              _c("b-col", { staticStyle: { "text-align": "right" } }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.devolucoes }
                  },
                  [_vm._v("Solicitar uma devolução")]
                ),
                _vm._v(" "),
                _vm.enviar.length > 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: { click: _vm.EnviarDevolucao }
                      },
                      [
                        _c("i", { staticClass: "fa fa-send" }),
                        _vm._v(" Enviar Devoluções")
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _vm.totalSelecionados > 0
            ? _c(
                "p",
                {
                  staticClass: "text-left",
                  staticStyle: { "margin-bottom": "0px" }
                },
                [
                  _c("strong", { staticClass: "text-primary" }, [
                    _vm._v("Devoluções Selecionadas: ")
                  ]),
                  _vm._v(_vm._s(_vm.enviar.length) + "\r\n            ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-table", {
            attrs: {
              column: _vm.colunas,
              data: _vm.dataComputed,
              actions: _vm.actionsTable
            },
            on: {
              change: _vm.changeSelecionados,
              show: _vm.show,
              markAll: _vm.changeMarcarTodos
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "modal-Devolve", tabindex: "-1", role: "dialog" }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h3", { staticClass: "modal-title text-primary" }, [
                  _vm._v("Solicitação de Devolução da Nota "),
                  _c("small", [_vm._v(_vm._s(_vm.danfe.numero))])
                ]),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "ul",
                  { staticClass: "text-danger" },
                  [
                    _vm._l(_vm.errors, function(error) {
                      return _c("li", { key: error }, [_vm._v(_vm._s(error))])
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.danfe.danfe_id,
                          expression: "danfe.danfe_id"
                        }
                      ],
                      attrs: { type: "hidden" },
                      domProps: { value: _vm.danfe.danfe_id },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.danfe, "danfe_id", $event.target.value)
                        }
                      }
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.danfe.status == "LIBERADO"
                  ? _c("div", [
                      _vm.danfe.analise.length > 0
                        ? _c("div", [
                            _c("h4", [
                              _vm._v(
                                "\r\n                                Demostrativo da análise, mediante a solicitação de devolução.\r\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-bordered table-condensed table-hover"
                                  },
                                  [
                                    _vm._m(1),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.danfe.analise, function(
                                        an,
                                        i
                                      ) {
                                        return _c("tr", { key: i }, [
                                          _c("td", [
                                            _vm._v(
                                              " " + _vm._s(an.descricao) + " "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              " " + _vm._s(an.multa) + " % "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              " " + _vm._s(an.quantidade) + " "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              " R$ " +
                                                _vm._s(
                                                  parseFloat(
                                                    an.media
                                                  ).toLocaleString("pt-BR")
                                                ) +
                                                " "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              " R$ " +
                                                _vm._s(
                                                  parseFloat(
                                                    an.nf_x_media
                                                  ).toLocaleString("pt-BR")
                                                ) +
                                                " "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              " R$ " +
                                                _vm._s(
                                                  parseFloat(
                                                    an.taxa
                                                  ).toLocaleString("pt-BR")
                                                ) +
                                                " "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              " R$ " +
                                                _vm._s(
                                                  parseFloat(
                                                    an.total
                                                  ).toLocaleString("pt-BR")
                                                ) +
                                                " "
                                            )
                                          ])
                                        ])
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.danfe.obs,
                            expression: "danfe.obs"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { readonly: "" },
                        domProps: { value: _vm.danfe.obs },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.danfe, "obs", $event.target.value)
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.danfe.status == "ABERTO" || _vm.danfe.status != "LIBERADO"
                  ? _c("div", [
                      _c("div", { staticClass: "row" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("span", [_vm._v(_vm._s(_vm.danfe.nome))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("span", [_vm._v(_vm._s(_vm.danfe.chave))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("span", [_vm._v(_vm._s(_vm.danfe.numero))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Tipo Devolução:")]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.danfe.tipo,
                                    expression: "danfe.tipo"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { id: "tipo-devolve" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.danfe,
                                      "tipo",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { domProps: { value: 1 } }, [
                                  _vm._v("Total")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 2 } }, [
                                  _vm._v("Parcial")
                                ])
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Tipo de Frete:")]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.danfe.frete,
                                    expression: "danfe.frete"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { id: "tipo-frete" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.danfe,
                                      "frete",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { domProps: { value: 1 } }, [
                                  _vm._v("Proprio")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 2 } }, [
                                  _vm._v("Coleta")
                                ])
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Justificativa:")]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.danfe.justificativa,
                                  expression: "danfe.justificativa"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { rows: "2", cols: "3" },
                              domProps: { value: _vm.danfe.justificativa },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.danfe,
                                    "justificativa",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _vm.files
                              ? _c("img", {
                                  staticClass: "img-rounded vue-image",
                                  attrs: { src: _vm.files, width: "200" }
                                })
                              : _vm._e()
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _vm.danfe.tipo == 2
                          ? _c("div", { staticClass: "form-group" }, [
                              _c(
                                "table",
                                { staticClass: "table table-responsive" },
                                [
                                  _vm._m(5),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.danfe.itens, function(itens) {
                                      return _c("tr", { key: itens.id }, [
                                        _c("td", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.itensDevolve,
                                                expression: "itensDevolve"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              value: itens.id,
                                              checked: Array.isArray(
                                                _vm.itensDevolve
                                              )
                                                ? _vm._i(
                                                    _vm.itensDevolve,
                                                    itens.id
                                                  ) > -1
                                                : _vm.itensDevolve
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = _vm.itensDevolve,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = itens.id,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.itensDevolve = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.itensDevolve = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.itensDevolve = $$c
                                                }
                                              }
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "\r\n                                                " +
                                              _vm._s(itens.produto) +
                                              "\r\n                                            "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "\r\n                                                " +
                                              _vm._s(itens.descricao) +
                                              "\r\n                                            "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "\r\n                                                " +
                                              _vm._s(itens.quantidade) +
                                              "\r\n                                            "
                                          )
                                        ])
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _vm.danfe.status == "ABERTO"
                  ? _c(
                      "span",
                      { staticClass: "disabled" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary", id: "botao-salvar" },
                            on: { click: _vm.salvaAlteracao }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-arrow-circle-right"
                            }),
                            _vm._v(" Alterar")
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.danfe.status == "ABERTO"
                  ? _c("span", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-warning",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              return _vm.deleta(_vm.danfe.devolucao)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-trash" }),
                          _vm._v(" Deletar")
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [_vm._v("Cancelar")]
                ),
                _vm._v(" "),
                _vm.danfe.status == "ABERTO" ? _c("span") : _vm._e()
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Regras")]),
        _vm._v(" "),
        _c("th", [_vm._v("% Multa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Quantidade")]),
        _vm._v(" "),
        _c("th", [_vm._v("Media")]),
        _vm._v(" "),
        _c("th", [_vm._v("NF. Vs Media")]),
        _vm._v(" "),
        _c("th", [_vm._v("Taxa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subtotal")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h5", [_vm._v("Revendedora")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h5", [_vm._v("Chave da Nota")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h5", [_vm._v("Número da Nota")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("Selecione...")]),
      _vm._v(" "),
      _c("th", [_vm._v("Produto")]),
      _vm._v(" "),
      _c("th", [_vm._v("Descricao")]),
      _vm._v(" "),
      _c("th", [_vm._v("Quantidade")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e56e179", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e56e179","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/devolucao/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1e56e179","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/devolucao/List.vue
// module chunks = 2